import { createContext, useContext } from 'react';

export type AppModalData = {
    id: string;
    payload?: any;
};

export type AppModalContextType = {
    modalData: AppModalData | null;
    setModalData: (data: AppModalData | null) => void;
};

export const AppModalContext = createContext<AppModalContextType>({
    modalData: null,
    setModalData: () => {},
});

export function useAppModal() {
    return useContext(AppModalContext);
}
